import { UPLOAD_CA } from 'containers/FileUploadOverlay/constants';
import { List, Record } from 'immutable';
import { merge } from 'ramda';
import {
  DELETE_CA,
  FETCH_CERTIFICATION_AUTHORITIES,
  PATCH_CA,
  SHOW_UPLOAD,
} from './constants';

const InitialState = Record({
  data: new List(),
  showFileUpload: false,
});

const initialState = new InitialState();

function certificationAuthoritiesReducer(
  state = initialState,
  action = undefined,
) {
  switch (action.type) {
    case `${FETCH_CERTIFICATION_AUTHORITIES}_ERROR`:
    case `${FETCH_CERTIFICATION_AUTHORITIES}_START`:
      return state.set('data', new List());
    case `${FETCH_CERTIFICATION_AUTHORITIES}_SUCCESS`:
      return state.set('data', new List(action.payload));
    case `${DELETE_CA}_SUCCESS`: {
      const foundIndex = state.data.findIndex((s) => s.id === action.payload);
      if (foundIndex > -1) {
        return state.deleteIn(['data', foundIndex]);
      }
      return state;
    }
    case `${PATCH_CA}_SUCCESS`: {
      const foundIndex = state.data.findIndex(
        (s) => s.id === action.payload.id,
      );
      if (foundIndex > -1) {
        return state.updateIn(['data', foundIndex], (ca) =>
          merge(ca, action.payload),
        );
      }
      return state;
    }
    case `${UPLOAD_CA}_SUCCESS`:
      return state
        .update('data', (data) => data.push(action.payload.ca))
        .set('showFileUpload', false);
    case `${UPLOAD_CA}_ERROR`:
      return state.set('showFileUpload', false);
    case SHOW_UPLOAD:
      return state.set('showFileUpload', action.payload);
    default:
      return state;
  }
}

export default certificationAuthoritiesReducer;
